import React from "react";
import { Entity } from "@common/types/entity";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { HStack } from "@design-system/HStack/HStack";
import { useUser } from "@hooks/useUser";
import { getOwnershipEntityDisplayName } from "./ownershipGraph.helpers";
import styles from "./OwnershipEntityIdentity.module.scss";

interface OwnershipEntityIdentityProps {
    entity: Entity;
    children?: React.ReactNode;
}

export const OwnershipEntityIdentity: React.FC<
    OwnershipEntityIdentityProps
> = ({ entity, children }) => {
    const currentUser = useUser();
    const isCurrentUserPersonalEntity =
        entity.isPersonal &&
        entity.user != null &&
        entity.userId === currentUser?.id;
    return (
        <HStack gap={8} align="center" className={styles.identity}>
            {isCurrentUserPersonalEntity && entity.user ? (
                <UserAvatar user={entity.user} size="xs" aria-hidden />
            ) : (
                <EntityAvatar entity={entity} size="xs" aria-hidden />
            )}
            <span className={styles.name}>
                {getOwnershipEntityDisplayName(entity)}
            </span>
            {children}
        </HStack>
    );
};
